import React from "react";
import { Container, Row, Col } from "reactstrap";
import { Link } from "react-router-dom";

// SVG Icons
const IconScale = () => (
  <svg width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="url(#compareGrad1)" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <defs>
      <linearGradient id="compareGrad1" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#7d82ff" />
        <stop offset="100%" stopColor="#a78bfa" />
      </linearGradient>
    </defs>
    <path d="M12 3v18" />
    <path d="M5 7l7-4 7 4" />
    <path d="M3 13l2-6 4 6H3z" />
    <path d="M15 13l2-6 4 6h-6z" />
  </svg>
);

const IconVsFirebase = () => (
  <svg width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="url(#compareGrad2)" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <defs>
      <linearGradient id="compareGrad2" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#f59e0b" />
        <stop offset="100%" stopColor="#ef4444" />
      </linearGradient>
    </defs>
    <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2" />
  </svg>
);

const IconArrowRight = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <line x1="5" y1="12" x2="19" y2="12" />
    <polyline points="12 5 19 12 12 19" />
  </svg>
);

const IconBook = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#7d82ff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20" />
    <path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z" />
  </svg>
);

const IconDollar = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#10B981" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <line x1="12" y1="1" x2="12" y2="23" />
    <path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6" />
  </svg>
);

const IconCode = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#f59e0b" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="16 18 22 12 16 6" />
    <polyline points="8 6 2 12 8 18" />
  </svg>
);

const IconHelp = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#a78bfa" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="10" />
    <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3" />
    <line x1="12" y1="17" x2="12.01" y2="17" />
  </svg>
);

const IconAPI = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#ef4444" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M18 20V10" />
    <path d="M12 20V4" />
    <path d="M6 20v-6" />
  </svg>
);

const comparisons = [
  {
    icon: <IconScale />,
    title: "Build vs Buy Guide",
    subtitle: "Engineering Trade-offs",
    description:
      "Should you build your own app update system or use a managed platform? Explore the engineering effort, ongoing maintenance costs, and hidden complexity of building versus buying.",
    tags: ["Engineering", "Cost Analysis", "Decision Guide"],
    url: "/compare/build-vs-buy",
    gradient: "linear-gradient(135deg, rgba(125, 130, 255, 0.12), rgba(167, 139, 250, 0.06))",
    borderColor: "rgba(125, 130, 255, 0.25)",
  },
  {
    icon: <IconVsFirebase />,
    title: "App Upgrade vs Firebase Remote Config",
    subtitle: "Platform Comparison",
    description:
      "Firebase Remote Config is great for feature flags and runtime configuration. But is it the right tool for managing app version updates? See a head-to-head breakdown.",
    tags: ["Firebase", "Comparison", "Force Update"],
    url: "/compare/app-upgrade-vs-firebase-remote-config",
    gradient: "linear-gradient(135deg, rgba(245, 158, 11, 0.12), rgba(239, 68, 68, 0.06))",
    borderColor: "rgba(245, 158, 11, 0.25)",
  },
];

const quickLinks = [
  {
    icon: <IconDollar />,
    label: "Pricing",
    url: "/pricing",
    isExternal: false,
  },
  {
    icon: <IconBook />,
    label: "Documentation",
    url: "https://appupgrade.dev/docs/",
    isExternal: true,
  },
  {
    icon: <IconCode />,
    label: "SDK Integration",
    url: "https://appupgrade.dev/docs/integration-with-app-upgrade-using-sdk.html",
    isExternal: true,
  },
  {
    icon: <IconHelp />,
    label: "FAQ",
    url: "https://appupgrade.dev/docs/app-upgrade-faq",
    isExternal: true,
  },
  {
    icon: <IconAPI />,
    label: "API Reference",
    url: "https://appupgrade.dev/docs/integration-with-app-upgrade-using-api",
    isExternal: true,
  },
];

const Compare = () => {
  return (
    <section className="landing-page-section bg-landing-page" style={{ minHeight: "100vh" }}>
      <Container>
        {/* Hero Header */}
        <Row className="justify-content-center text-center" style={{ paddingTop: "5rem", paddingBottom: "2rem" }}>
          <Col lg={8}>
            <p
              style={{
                fontSize: "0.8rem",
                fontWeight: 600,
                letterSpacing: "0.15em",
                textTransform: "uppercase",
                color: "#7d82ff",
                marginBottom: "1rem",
              }}
            >
              Comparisons & Guides
            </p>
            <h1 className="text-white font-weight-bold" style={{ fontSize: "2.6rem", lineHeight: 1.2, marginBottom: "1.2rem" }}>
              Make an Informed{" "}
              <span className="light-purple-gradient">Decision</span>
            </h1>
            <p className="landing-muted-text" style={{ fontSize: "1.15rem", lineHeight: 1.7, margin: "0 auto" }}>
              Explore in-depth comparisons and guides to help you choose the right app update strategy for your team.
            </p>
          </Col>
        </Row>

        {/* Comparison Cards */}
        <Row className="justify-content-center" style={{ marginTop: "2rem", marginBottom: "3rem" }}>
          {comparisons.map((item, index) => (
            <Col lg={6} md={6} sm={12} className="mb-4" key={index}>
              <Link to={item.url} style={{ textDecoration: "none" }}>
                <div
                  style={{
                    background: item.gradient,
                    border: `1px solid ${item.borderColor}`,
                    borderRadius: "1rem",
                    padding: "2rem",
                    minHeight: "280px",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-between",
                    transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
                    cursor: "pointer",
                    position: "relative",
                    overflow: "hidden",
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = "translateY(-4px)";
                    e.currentTarget.style.boxShadow = `0 20px 40px -12px ${item.borderColor}`;
                    e.currentTarget.style.borderColor = item.borderColor.replace("0.25", "0.5");
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = "translateY(0)";
                    e.currentTarget.style.boxShadow = "none";
                    e.currentTarget.style.borderColor = item.borderColor;
                  }}
                >
                  <div>
                    <div style={{ marginBottom: "1rem" }}>{item.icon}</div>
                    <p
                      style={{
                        fontSize: "0.75rem",
                        fontWeight: 600,
                        letterSpacing: "0.1em",
                        textTransform: "uppercase",
                        color: "#939db8",
                        marginBottom: "0.4rem",
                      }}
                    >
                      {item.subtitle}
                    </p>
                    <h3 className="text-white font-weight-bold" style={{ fontSize: "1.35rem", marginBottom: "0.8rem" }}>
                      {item.title}
                    </h3>
                    <p style={{ color: "#939db8", fontSize: "0.95rem", lineHeight: 1.6, marginBottom: "1rem" }}>
                      {item.description}
                    </p>
                    <div style={{ display: "flex", flexWrap: "wrap", gap: "0.5rem", marginBottom: "1.5rem" }}>
                      {item.tags.map((tag, i) => (
                        <span
                          key={i}
                          style={{
                            fontSize: "0.72rem",
                            fontWeight: 500,
                            padding: "0.25rem 0.7rem",
                            borderRadius: "999px",
                            background: "rgba(255, 255, 255, 0.05)",
                            color: "#b0b8cc",
                            border: "1px solid rgba(255, 255, 255, 0.08)",
                          }}
                        >
                          {tag}
                        </span>
                      ))}
                    </div>
                  </div>
                  <div style={{ display: "flex", alignItems: "center", gap: "0.5rem", color: "#7d82ff", fontWeight: 600, fontSize: "0.9rem" }}>
                    Read comparison <IconArrowRight />
                  </div>
                </div>
              </Link>
            </Col>
          ))}
        </Row>

        <hr style={{ borderColor: "rgba(255, 255, 255, 0.08)", margin: "2rem 0 3rem" }} />

        {/* Quick Links Section */}
        <Row className="justify-content-center text-center" style={{ marginBottom: "2rem" }}>
          <Col lg={8}>
            <h3 className="text-white font-weight-bold" style={{ fontSize: "1.5rem", marginBottom: "0.6rem" }}>
              Explore More Resources
            </h3>
            <p className="landing-muted-text" style={{ fontSize: "0.95rem" }}>
              Dive deeper into App Upgrade's features, pricing, and developer documentation.
            </p>
          </Col>
        </Row>
        <Row className="justify-content-center" style={{ marginBottom: "4rem" }}>
          <Col lg={12}>
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "repeat(auto-fit, minmax(180px, 1fr))",
                gap: "1rem",
              }}
            >
              {quickLinks.map((link, i) => {
                const inner = (
                  <div
                    key={i}
                    style={{
                      background: "rgba(255, 255, 255, 0.03)",
                      border: "1px solid rgba(255, 255, 255, 0.08)",
                      borderRadius: "0.75rem",
                      padding: "1.25rem",
                      textAlign: "center",
                      transition: "all 0.25s ease",
                      cursor: "pointer",
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.background = "rgba(255, 255, 255, 0.06)";
                      e.currentTarget.style.borderColor = "rgba(125, 130, 255, 0.3)";
                      e.currentTarget.style.transform = "translateY(-2px)";
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.background = "rgba(255, 255, 255, 0.03)";
                      e.currentTarget.style.borderColor = "rgba(255, 255, 255, 0.08)";
                      e.currentTarget.style.transform = "translateY(0)";
                    }}
                  >
                    <div style={{ marginBottom: "0.6rem" }}>{link.icon}</div>
                    <span style={{ color: "#e2e8f0", fontWeight: 500, fontSize: "0.9rem" }}>{link.label}</span>
                  </div>
                );

                return link.isExternal ? (
                  <a key={i} href={link.url} target="_blank" rel="noreferrer" style={{ textDecoration: "none" }}>
                    {inner}
                  </a>
                ) : (
                  <Link key={i} to={link.url} style={{ textDecoration: "none" }}>
                    {inner}
                  </Link>
                );
              })}
            </div>
          </Col>
        </Row>

        <hr style={{ borderColor: "rgba(255, 255, 255, 0.08)", margin: "0 0 3rem" }} />

        {/* CTA */}
        <Row className="justify-content-center text-center" style={{ paddingBottom: "4rem" }}>
          <Col lg={8}>
            <div className="title text-center mb-5">
              <span className="text-white text-landing-h1" style={{ fontSize: "2.0rem" }}>
                Start with{" "}
                <span className="light-purple-gradient">App Upgrade</span>,
                today.
              </span>
              <p
                className="light-purple-gradient mt-3"
                style={{
                  fontSize: "0.8rem",
                  fontWeight: "normal",
                  color: "rgba(144, 97, 249, 1)",
                }}
              >
                Start with <b>free 15 days</b> trial. No credit card required.
              </p>
            </div>
            <div
              className="mt-5"
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "center",
                gap: "1.5rem",
              }}
            >
              <div style={{ textAlign: "center" }}>
                <a
                  target="_blank"
                  href="https://appupgrade.dev/signup"
                  className="btn btn-cta btn-full-width outline-text glowing outline-shadow"
                  rel="noreferrer"
                >
                  Get started →
                </a>
              </div>
              <div style={{ textAlign: "center" }}>
                <a
                  target="_blank"
                  href="mailto:support@appupgrade.dev"
                  className="btn btn-cta btn-full-width outline-text glowing outline-shadow"
                  rel="noreferrer"
                  style={{ padding: ".375rem .75rem" }}
                >
                  Contact us →
                </a>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default Compare;
